import { render } from "./Avogado6Page.vue?vue&type=template&id=ae21faf6&scoped=true"
import script from "./Avogado6Page.vue?vue&type=script&lang=js"
export * from "./Avogado6Page.vue?vue&type=script&lang=js"

import "./Avogado6Page.vue?vue&type=style&index=0&id=ae21faf6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae21faf6"]])

export default __exports__